import { Component } from '@angular/core';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html'
})
export class ReferencesComponent {
}
